import { Component, Input, OnInit } from '@angular/core';
import { Constants } from '../constants/constants';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { ToastService } from '../service/toast.service';
import { UtilService } from '../service/util.service';

@Component({
  selector: 'app-vehicle-list',
  templateUrl: './vehicle-list.component.html',
  styleUrls: ['./vehicle-list.component.scss']
})
export class VehicleListComponent implements OnInit {

  @Input() account: any;
  @Input() vehicleList: any = [];

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toastService: ToastService) { }

  ngOnInit() {
    this.getAccountVehicles();
  }

  getAccountVehicles() {
    this.utilService.showSpinner();
    this.apiService.getAccountVehicles(this.account.id).then((data) => {
      this.utilService.hideSpinner();
      this.vehicleList = data;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAccountVehicles();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        // else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

}
